import React, {Component} from 'react';
import axios from 'axios'
import * as config from '../../config';
import $ from 'jquery'
import Spinner from '../Shared/Spinner';


class NoBindings extends Component {
    constructor(props){
        super(props)

        this.state = {
            fetching:false,
            error:false,
            errorText:""
        }
    }
    handleFileChange(e){

        this.setState({
            fetching:true
        })

       let file =e.target.files[0];

        if(!file && this.state.fetching) return null;

        let data  = new FormData();
        data.append("file",file)

        axios.post(
            config.apiUrl + "/offers/uploadbindings",
           //"https://api.xmldatafeed.com/swagger/ui/images/logo_small-png",
            data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                responseType: 'blob',
            }
        ).then((response)=>{

            // var blob = new Blob([response.data]);
            // var url = windowUrl.createObjectURL(blob);

            // let url =  new Buffer(response.data, 'binary').toString('base64')
            //
            // window.open(url)


            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.txt'); //or any other extension
            document.body.appendChild(link);
            link.click();

            this.setState({
                fetching:false,
                error:false,
                errorText:""
            },()=>{
                this.file.value=""
                }

            )
        }).catch((error)=>{
            this.setState({
                fetching:false,
                error:true
            })
        })
    }
    render() {
        return (
            <div className="form-group">
                <label>Получить отсутствующие привязки по файлу: </label>
                <div className="uploader">
                    <input type="file" className="file-styled"  onChange={(e)=>this.handleFileChange(e)} ref={(input)=>this.file = input}/>
                    <span className="filename" >
                         {
                             this.state.fetching ?
                                 <Spinner
                                     styles={{
                                         backgroundColor: "#37474F"
                                     }}
                                 />
                                 : null
                         }
                    </span>
                    <span className="action btn btn-default" >Выберите файл</span>
                </div>
            </div>
            
        );
    }
}

export default NoBindings;



// WEBPACK FOOTER //
// ./src/components/Company/NoBindings.jsx